import { COMPANY_LIST } from './actionTypes';

export const setReduxCompanyList = (data) => {
  return {
    type: COMPANY_LIST,
    data,
  };
};
